module.exports = __webpack_public_path__ + "img/local-top-bg.371197f4.png";